module.exports = __webpack_public_path__ + "static/671e8075.4.gif";